import "./MapsOverview.scss";

export default {
  name: "MapsOverview",
  data: () => ({}),
  async mounted() {},
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isMapsAdmin() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:maps_admin")
      );
    }
  }
};
